export default "__VITE_ASSET__BpK4QOxf__"